<template>
    <div class="list">
        <slot />
    </div>
</template>

<script>
    export default {
        name: 'List'
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";
</style>
